import { Component, Event, EventEmitter, h, Listen, Prop } from '@stencil/core';
import { ButtonIconType } from '../../utils/icon-types';

@Component({
  tag: 'biel-search-ask-ai-button',
  styleUrl: 'biel-search-ask-ai-button.css',
  shadow: true,
})
export class BielSearchAskAiButton {
  @Prop() resultTitle: string;
  @Prop() resultFragment: string;
  @Prop() isSelected: boolean;
  @Prop() bielId: string;
  @Prop() aiIcon: ButtonIconType = 'bot';

  @Event() askAiClicked: EventEmitter<{ bielId: string }>;

  @Listen('keydown', { target: 'window' })
  handleKeyDown(event: KeyboardEvent) {
    if (this.isSelected && event.key === 'Enter') {
      event.preventDefault();
      this.handleAskAiClick();
    }
  }

  handleAskAiClick() {
    this.askAiClicked.emit({ bielId: this.bielId });
  }

  render() {
    return (
      <a
        class="biel-search-ask-ai"
        part="link"
        tabIndex={this.isSelected ? 0 : -1}
        onClick={() => this.handleAskAiClick()}
      >
        <div
          class={`biel-search-ask-ai-container ${this.isSelected ? 'selected' : ''}`}
          part="container"
        >
          <div class="biel-search-ask-ai-icon" part="icon">
            <biel-icon type={this.aiIcon} width="24" height="24"></biel-icon>
          </div>
          <div class="biel-search-ask-ai-text-container" part="text-container">
            <span class="biel-search-ask-ai__title" part="title">
              {this.resultTitle}
            </span>
            <span class="biel-search-ask-ai__description" part="description">
              {this.resultFragment}
            </span>
          </div>
        </div>
      </a>
    );
  }
}
